import { Mapper } from '../../../common';
import { WorkingHoursByRangeDistributionAggregateRoot } from '../../../core/domain/aggregates/working-hours/working-hours-by-range-distribution.aggregate.root';
import { WorkingHoursByRangeDistributionResponseDto } from '../../../interface/dtos/working-hours/working-hours-by-range-distribution.response.dto';

export type IWorkingHoursByRangeDistibutionAggregateRootMapper = Mapper<
  WorkingHoursByRangeDistributionAggregateRoot,
  WorkingHoursByRangeDistributionResponseDto
>;

export class WorkingHoursByRangeDistibutionAggregateRootMapper
  implements
    Omit<IWorkingHoursByRangeDistibutionAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: WorkingHoursByRangeDistributionAggregateRoot
  ): WorkingHoursByRangeDistributionResponseDto {
    return WorkingHoursByRangeDistibutionAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: WorkingHoursByRangeDistributionAggregateRoot
  ): WorkingHoursByRangeDistributionResponseDto {
    return {
      data: entity.data.map((item) => ({
        count: item.count,
        date: item.date,
        lower: item.lower,
        middle: item.middle,
        upper: item.upper,
      })),
    };
  }
}
